import { Component, Element, Host, Prop, h } from '@stencil/core';

// declare global {
//   interface Window {
//     MktoForms2: any;
//   }
// }

@Component({
  tag: 'cradlepoint-marketo-form',
  styleUrl: 'marketo-form.css',
  shadow: true,
})
export class MarketoForm {
  @Element() host: HTMLElement;

  @Prop() domain   : string = 'info.cradlepoint.com';
  @Prop() marketoId: string = '473-ZZR-267';
  @Prop() scriptSrc: string = `${this.domain}/js/forms2/js/forms2.min.js`;
  @Prop() formId   : string;

  componentDidLoad() {
    (async (window) => {
      const marketoScript = window.document.querySelector(`script[src="//${this.scriptSrc}"]`);

      if (!marketoScript) {
        const script = window.document.createElement('script');
        script.src = `//${this.scriptSrc}`;
        window.document.body.appendChild(script);
      }

      const form = window.document.createElement('form');
      form.id = `mktoForm_${this.formId}`;
      this.host.appendChild(form);

      const componentInterval = setInterval(() => {
        if (window['MktoForms2']) {
          window['MktoForms2'].loadForm(`//${this.domain}`, `${this.marketoId}`, `${this.formId}`);
          clearInterval(componentInterval);
        }
      }, 100);
    })(window)
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }

}
